import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3ZM5 19H19V5H5V19ZM15.06 12.62L11.17 15.22C11.0573 15.2962 10.926 15.3403 10.7901 15.3476C10.6543 15.3548 10.519 15.325 10.3988 15.2613C10.2786 15.1976 10.178 15.1024 10.1077 14.9859C10.0375 14.8694 10.0002 14.736 10 14.6V9.4C10.0002 9.26396 10.0375 9.13055 10.1077 9.01405C10.178 8.89756 10.2786 8.80236 10.3988 8.73867C10.519 8.67497 10.6543 8.64516 10.7901 8.65244C10.926 8.65973 11.0573 8.70382 11.17 8.78L15.06 11.38C15.1632 11.4472 15.2479 11.5391 15.3066 11.6474C15.3653 11.7557 15.396 11.8769 15.396 12C15.396 12.1231 15.3653 12.2443 15.3066 12.3526C15.2479 12.4609 15.1632 12.5528 15.06 12.62Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgSlideshowOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgSlideshowOutline;
